module.exports = __webpack_public_path__ + "static/media/google_play_logo.8d88d1e8.png";